<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <div class="search-line">
      <div class="btn-box">
        <input-select selectTitle="物资类目" :selectKey="'categoryCode'" :selectData="categoryTypeList" @search="search" style="margin-right: 10px"/>
        <input-select selectTitle="盘点状态" :selectKey="'counted'" :selectData="checkTypeList" @search="search" style="margin-right: 10px"/>
        <input-select selectTitle="物资状态" :selectKey="'materialsStatus'" :selectData="materialsTypeList" @search="search"/>
      <!-- <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">创建时间</span>
        <el-date-picker v-model="timevalue" size="small" type="daterange" style="width: 280px;" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd">
        </el-date-picker> -->
      </div>
      <div style="display:flex;justify-content:flex-start;align-items:center;">
      <input-search  placeholder="物资名称/物资编号/领用人"  @search="searchKey" />
        <button-export
        :href="exportUrl"
        :beforeDownload="beforeDownload"
        download="download.xls"
        style="margin: 0 0 0 8px"
        value="导出"/>
      </div>
    </div>
<!--    <div class="search-line">-->
<!--      <div>-->
<!--       -->
<!--      </div>-->
<!--      <div>-->
<!--        -->
<!--      </div>-->
<!--      <div>-->
<!--       -->
<!--      </div>-->
<!--    </div>-->
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr"   :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @goToModifyPage="goToModifyPage"></table-main>

    <el-dialog
      title="修改备注"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
     <el-input v-model="formData.memo" size="small" style="width: 280px" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取 消</el-button>
        <el-button type="primary" size="small" @click="confirm">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Material";
import { bus } from "../../../utils/bus";
import ButtonAdd from "../../../components/common/buttons/button-add";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb,
    ButtonCancel,
    ButtonConfirm,
    TextTitle
  },
  name: "material-inventory-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "物资盘点"
        }
      ],
      tableHead: [
        {
          prop: "personName",
          label: "领用人姓名"
        },
        {
          prop: "enterpriseName",
          label: "领用人单位"
        },
        {
          prop: "materialsName",
          label: "物资名称"
        },
        {
          prop: "materialsNumber",
          label: "物资编号"
        },
        {
          prop: "categoryName",
          label: "物资类目"
        },
        {
          prop: "applyNumber",
          label: "数量"
        },
        {
          prop: "countDate",
          label: "盘点时间"
        },
        {
          prop: "materialsTextStatus",
          label: "物资状态"
        },
        {
          prop: "countedStatus",
          label: "盘点状态"
        },
        {
          prop: "countPersonName",
          label: "盘点人"
        },
        {
          prop: "memo",
          label: "备注"
        }
      ],
      tableData: [],
      mainTitle: "查看盘点列表",
      subheading: "",
      operationArr: ["modify"],
      exportUrl: "",
      requestData: {
        pageSize: 10,
        pageNum: 1,
        taskCode: this.$route.params.id,
        searchKey: "",
        materialsStatus: "",
        categoryName: "",
        code: "",
        counted: "",
        startTime: "",
        endTime: "",
        categoryCode: ""
      },
      total: 0,
      timevalue: [],
      checkTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: false,
          label: "未盘点"
        },
        {
          key: true,
          label: "已盘点"
        }
      ],
      materialsTypeList: [
        {
          key: "",
          label: "全部"
        },
        {
          key: 1,
          label: "正常"
        },
        {
          key: 2,
          label: "遗失"
        },
        {
          key: 3,
          label: "异常"
        },
        {
          key: 4,
          label: "报废"
        }
      ],
      categoryTypeList: [],
      dialogVisible: false,
      countListCode: "",
      formData: {}
    };
  },
  created() {
    this.getCategoryList();
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportCountList}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${
        this.requestData.searchKey
      }&startTime=${this.requestData.startTime}&endTime=${
        this.requestData.endTime
      }&materialsStatus=${this.requestData.materialsStatus}&categoryCode=${
        this.requestData.categoryCode
      }&counted=${this.requestData.counted}&taskCode=${
        this.requestData.taskCode
      }`;
    },
    getCategoryList(searchKey) {
      this.$axios
        .post(api.getCategoryList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            list.map(v => {
              console.log(v);
              v.key = v.code;
              v.label = v.categoryName;
            });
            this.categoryTypeList = list;
            this.categoryTypeList.unshift({ key: "", label: "全部" });
          }
        })
        .catch(errorHandler("获取物资类目列表失败"));
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0] || "";
        this.requestData.endTime = this.timevalue[1] || "";
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      this.$axios
        .post(api.getCountListPage, this.requestData)
        .then(res => {
          let list = res.data.data.list;
          list.map(v => {
            if (v.counted) {
              v.countedStatus = "已盘点";
            } else {
              v.countedStatus = "未盘点";
            }
            if (v.materialsStatus === "1") {
              v.materialsTextStatus = "正常";
            } else if (v.materialsStatus === "2") {
              v.materialsTextStatus = "遗失";
            } else if (v.materialsStatus === "3") {
              v.materialsTextStatus = "异常";
            } else if (v.materialsStatus === "4") {
              v.materialsTextStatus = "报废";
            } else {
              v.materialsTextStatus = "--";
            }
          });
          this.total = res.data.data.total;
          this.tableData = list;
        })
        .catch(errorHandler("获取分页失败"));
    },
    getCountListByCode() {
      this.$axios
        .get(`${api.getCountListByCode}/${this.countListCode}`, {})
        .then(res => {
          console.log(res);
          this.formData = res.data.data;
        })
        .catch(errorHandler("查询失败"));
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    goToModifyPage(code) {
      this.dialogVisible = true;
      this.countListCode = code;
      this.getCountListByCode();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    cancel() {
      this.dialogVisible = false;
    },
    confirm() {
      this.$axios
        .post(api.updateCountList, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.getPage();
          }
        })
        .catch(errorHandler("修改失败"));
      this.dialogVisible = false;
    }
  },
  watch: {
    timevalue() {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/MaterialInventory/InventoryList.vue